import styled from 'styled-components';
import { BaseContainer } from 'styles/sharedStyles';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

export const FacetFiltersContainer = styled.div`
  border-radius: 5px;
  min-width: 250px;
  background: white;
`;

export const FilterHeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px 0px 10px;
`;

export const FilterContainer = styled.div`
  background: white;
  border-radius: 5px;
  padding: 5px 8px;
`;

export const Line = styled.hr`
  margin: 0px;
  border-color: rgba(244, 244, 244, 0.3);
`;

export const FilterTitle = styled.div`
  padding: 10px 10px;
  font-weight: 450;
  color: rgba(0, 0, 0, 0.94);
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const FilterBody = styled(SimpleBar).attrs({ autoHide: false })`
  max-height: 300px;
  scrollbar-gutter: stable;
  flex-shrink: 0;


  .simplebar-track.simplebar-vertical {
    width: 12px;
    background: #f0f0f0;  
    border-radius: 4px;
  }

  .simplebar-scrollbar::before {
    background: #a0a0a0;
    border-radius: 4px;
  }

`;

export const SubCategoryContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SubCategoryItem = styled.div`
  padding: 5px 5px;
  display: flex;
  word-wrap: break-word;
  max-width: 220px;
  font-size: 0.95rem;
  color: rgba(103, 103, 103, 1);
  label {
    font-weight: 400;
    color: rgba(0, 0, 0, 0.64);
  }
`;

export const Checkbox = styled.input`
  margin-right: 4px;
`;

export const CategroyBaseContainer = styled(BaseContainer)`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  cursor: pointer;
`;

export const FilterHeading = styled.div`
  padding: 0px 10px;
  font-weight: 500;
  font-size: 1.2rem;
  background: white;
  border-radius: 5px;
`;
